var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpecialistDoctorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#774EEB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 31.0451L11.1016 29.0891C14.0825 27.9397 17.4034 28.0607 20.3043 29.4521L28.4668 33.344C29.4471 33.8078 29.8672 34.9976 29.4271 35.9856C29.007 36.9132 27.9667 37.377 27.0064 37.0544L19.7242 34.7757",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6 41.4707L9.10095 39.313C11.0615 37.9418 13.5623 37.6594 15.763 38.5265L23.7654 41.6522C25.4059 42.2974 27.2664 42.0353 28.6468 40.9464L41.1106 31.2872C42.1109 30.5209 42.291 29.0892 41.5307 28.0809C40.8105 27.1332 39.4901 26.9113 38.5098 27.5566L28.987 33.7272",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.0466 27.1735H23.6455V7.714C23.6455 6.76623 24.4058 6 25.346 6C26.2863 6 27.0466 6.76623 27.0466 7.714V27.1735Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27.0464 9.26672L29.4071 9.12554C29.7872 9.10538 30.1673 9.18601 30.5074 9.34733L33.8284 11.0009",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M36.5294 19.3089C36.5294 21.3053 34.9289 22.9387 32.9483 22.9387C30.9677 22.9387 29.3672 21.3255 29.3672 19.3089L30.4275 16.748",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M36.5293 19.309H29.3472L30.4075 16.7481L32.9483 10.5775L35.469 16.7481L36.5293 19.309Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M21.2847 15.9817C21.2847 17.9781 19.6843 19.6115 17.7037 19.6115C15.7231 19.6115 14.1226 17.9983 14.1226 15.9817L15.1829 13.4208",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M21.2847 15.9818H14.1226L15.1629 13.4208L17.7037 7.25024L20.2444 13.4208L21.2847 15.9818Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M23.6452 8.41977L22.0247 7.31071C21.7446 7.10905 21.4045 7.00824 21.0444 7.00824H16.323",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialistDoctorIcon);
export default __webpack_public_path__ + "static/media/specialistDoctorIcon.0b536b57114ea5383dd11892541d73d2.svg";
export { ForwardRef as ReactComponent };